import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SlackIconSvg from './icon-slack.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SlackIconSvg {...validProps} />;
}
SvgComponent.iconName = 'slackIcon';

/**
 * @deprecated This is a legacy icon
 */
export const SlackIcon = svgIconWrapper(SvgComponent);
